import React from "react";

export function Emoji({emojiStr, size = 24}: { emojiStr: string, size?: number, selected?: boolean }) {

    const sizeStr = `${size}px`;

    if (emojiStr.startsWith("<")) {
        const parts = emojiStr.split(":");
        const imgName = parts.length === 3 ? `${parts[1]}.gif` : `${parts[0].slice(1)}.png`;


        return <img
                tabIndex={-1}
                // contentEditable={false}
                data-tag={emojiStr}
                style={{
                    // display: "inline-block",
                    width: sizeStr,
                    height: sizeStr,
                    verticalAlign: "middle",
                }}
                src={"/images/" + imgName}
                alt={"emoji-" + emojiStr}
        />;
    }

    return <span
            // tabIndex={-1}
            suppressContentEditableWarning={true}
            contentEditable={true}
            style={{
                // userSelect:"none",
                // msTouchSelect: "none",
                // touchAction: "none",
                // pointerEvents: "none",
                width: sizeStr,
                height: sizeStr,
                verticalAlign: "middle",
                fontSize: `${Math.round(2 / 3 * size)}px`,
                // display: "inline-block",
                // width: 0,
                // display: "inline-flex",
                // alignItems: "center",
                // justifyContent: "center",
            }}
    >
        {emojiStr}
    </span>
}
